<template>
  <multipane class="custom-resizer">
    <PagesList class="listWrapper"  :style="style"/>
    <multipane-resizer></multipane-resizer>
    <div class="content">
      <transition name="slide" mode="out-in">
        <router-view :key="$route.fullPath"/>
      </transition>
    </div>
  </multipane>
</template>

<script>
import PagesList from '@/components/Page/PagesList'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import { getListWidthWatch, getListWidthCreated } from '@/helpers/listWidth'

export default {
  data () {
    return {
      style: {
        width: '100%'
      }
    }
  },
  components: {
    PagesList,
    Multipane,
    MultipaneResizer
  },
  watch: {
    '$route' (to, from) {
      getListWidthWatch(to, this.style, 1)
    }
  },
  created () {
    getListWidthCreated(this.$route.params, this.style, 1)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/page/Index.vue